import {
  SEU_COMPONENT_INPUT_PLACEHOLDER,
  SEU_COMPONENT_OUTPUT_PLACEHOLDER,
  SeuApiConverter,
  SeuComponentHandle,
  SeuComponentSplitterHandle,
  SeuComponentSplitterHandleApi,
} from '@seu-types';

export const outputHandlesConverter: SeuApiConverter<
  SeuComponentSplitterHandle[],
  SeuComponentSplitterHandleApi[]
> = {
  fromApi: (handles) => {
    if (!handles?.length) {
      return [{ id: SEU_COMPONENT_OUTPUT_PLACEHOLDER, values: [] }];
    }
    return handles.map((handle) => ({
      ...handle,
      values: handle.values.map((value) => ({
        ...value,
        operatingConditionId: String(value.operatingConditionId),
      })),
    }));
  },
  toApi: (handles) => {
    if (
      handles?.length === 1 &&
      handles[0].id === SEU_COMPONENT_OUTPUT_PLACEHOLDER
    ) {
      return [];
    }
    return handles.map((handle) => ({
      ...handle,
      values: handle.values.map((value) => ({
        ...value,
        operatingConditionId: Number(value.operatingConditionId),
      })),
    }));
  },
};

export const inputHandlesConverter: SeuApiConverter<
  SeuComponentHandle[],
  SeuComponentHandle[]
> = {
  fromApi: (handles) => {
    if (!handles?.length) {
      return [{ id: SEU_COMPONENT_INPUT_PLACEHOLDER, values: [] }];
    }
    return handles;
  },
  toApi: (handles) => {
    if (
      handles?.length === 1 &&
      handles[0].id === SEU_COMPONENT_INPUT_PLACEHOLDER
    ) {
      return [];
    }
    return handles;
  },
};
